<template>
	<v-container fluid grid-list-md class="pa-3">
		<v-layout row wrap>
			<v-flex xs12 sm12 md4 lg3>
				<v-stepper v-model="stepper.current_step" vertical>
					<v-stepper-step :complete="stepper.current_step > 1" step="1">
						Year <span class="font-weight-bold">{{ selected.year }}</span>
					</v-stepper-step>
					<v-stepper-content step="1">
						<v-card color="dull">
							<v-card-text>
								<v-select solo hide-details :items="stepper.years" item-value="name" item-text="name" v-model="selected.year">
								</v-select>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn flat>Cancel</v-btn>
								<v-btn color="primary" @click="year_on_continue">Continue</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="stepper.current_step > 2" step="2">
						Quarter <span class="font-weight-bold">{{ selected.quarter }}</span>
					</v-stepper-step>
					<v-stepper-content step="2">
						<v-card color="dull">
							<v-card-text>
								<v-select solo hide-details :items="stepper.quarters" item-value="name" item-text="name" v-model="selected.quarter"></v-select>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn flat @click="stepper.current_step = 1">Cancel</v-btn>
								<v-btn color="primary" @click="quarter_on_continue">Continue</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="stepper.current_step > 3" step="3">
						Company <span class="font-weight-bold">{{ selected.hub }}</span>
					</v-stepper-step>
					<v-stepper-content step="3">
						<v-card color="dull">
							<v-card-text>
								<v-select solo hide-details :items="stepper.hubs" item-value="name" item-text="name" v-model="selected.hub"></v-select>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn flat @click="stepper.current_step = 2">Cancel</v-btn>
								<v-btn color="primary" @click="hub_on_continue">Continue</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="stepper.current_step > 4" step="4">
						FITCOPER <span class="font-weight-bold">{{ selected.fitcorper_fullname }}</span>
						<small>{{ selected.department }}</small>
						<small>{{ selected.jobgrade_position }}</small>
					</v-stepper-step>
					<v-stepper-content step="4">
						<v-card color="dull">
							<v-card-text>
								<v-select solo hide-details :items="stepper.fitcorpers" @change="fitcorper_on_change($event)" item-text="full_name" item-value="user__username" v-model="selected.fitcorper"></v-select>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn flat @click="stepper.current_step = 3">Cancel</v-btn>
								<v-btn color="primary" @click="fitcorper_on_continue">Continue</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="stepper.current_step > 5" step="5">
						Form Type<span class="font-weight-bold">{{ selected.form_type }}</span>
						<small v-show="selected.form_type">{{ selected.form_info["form_list"] }}</small>
					</v-stepper-step>
					<v-stepper-content step="5">
						<v-card color="dull">
							<v-card-text>
								<v-select solo hide-details :items="stepper.forms_type" item-text="name" item-value="name" v-model="selected.form_type"></v-select>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn flat @click="stepper.current_step = 4; selected.form_type=''">Cancel</v-btn>
								<v-btn color="primary" @click="submit_on_click">Submit</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
				</v-stepper>

			</v-flex>

			<v-flex xs12 sm12 md8 lg9>
				<v-card>
					<v-card-text>
						<iframe id="frm_window" frameborder="0" style="min-height: 500px;" :src="selected.iframe.url" width="100%" :height="selected.iframe.height"></iframe>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";
import comm from "../../functions/communication.api";
import qb from "../../functions/query.builder";
import auth from "../../functions/auth";

export default {
	name: "Appraisal-Form-V2",
	async mounted() {
		general.App.set_page_title("mySuite : Appraisal Form (v2)");

		var forms = await comm.getFormData(
			'for rec in forms filter contains(rec.name,"Form 47") and rec.status == 1 return {"form_id":rec._id, "form_name":rec.name, "form_list": concat(rec.name," - ",rec.description)}'
		);
		this.base.all_forms = forms.data;

		var years = await comm.getFormData(
			'for rec in setting_year filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
		);
		this.stepper.years = years.data;

		var quarters = await comm.getFormData(
			'for rec in setting_quater filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
		);
		this.stepper.quarters = quarters.data;

		var appraisal_types = await comm.getFormData(
			'for rec in setting_appraisal_type filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
		);
		this.base.forms_type = appraisal_types.data;

		let cls_qb = new qb.QueryBuilder();
		cls_qb.Method = "all";
		cls_qb.Table = "emps_company";
		cls_qb.Select = ["id", "name", "parent_company_id__name"];

		var rule = new qb.Rule();
		rule
			.field("parent_company_id__name")
			.operator(qb.STR_OPERATOR.I_CONTAINS)
			.value("group");
		cls_qb.addRule(rule);

		cls_qb.Order = ["name"];
		var result = await general.wBackEndComm.PostData("process_qb/", cls_qb);

		if (result.data.Status == 1) {
			this.stepper.hubs = result.data.Body.records;
		} else {
			general.wMsgBox.Error(result.data.Description);
		}

		result = await general.wBackEndComm.GetData("fpes/get_down_stream_members/");
		if (result.data.Status == 1) {
			this.base.all_members = result.data.Body;
		} else {
			general.wMsgBox.Error(result.data.Description);
		}

		var self = this;
		function handleMessage(e) {
			if (e.data.event == "form_data_saved") {
				self.selected.iframe.height = e.data.window.height;
			}
			if (e.data.event == "form_loaded") {
				self.selected.iframe.height = e.data.window.height + 100;
			}
		}

		window.addEventListener("message", handleMessage, false);

	},
	data() {
		return {
			current_username: auth.getUsername(),
			userfullname: auth.getFullName(),
			base: {
				forms_type: [],
				all_members: [],
				all_forms: [],
			},
			stepper: {
				current_step: 1,
				years: [],
				quarters: [],
				hubs: [],
				fitcorpers: [],
				forms_type: [],
			},
			selected: {
				year: "",
				quarter: "",
				hub: "",
				fitcorper: "",
				fitcorper_fullname: "",
				jobgrade_position: "",
				department: "",
				form_type: "",
				form_info: {},
				iframe: {
					url: "",
					height: ""
				}
			},
		};
	},
	computed: {},
	methods: {
		async check_rec_exist() {
			var ret = false;

			var check = [
				"for rec in form_datas ",
				"filter contains(rec.form_id,'",
				this.selected.form_info.form_id,
				"') && contains(rec.submission.data.hub,'",
				this.selected.hub,
				"') && contains(rec.submission.data.department,'",
				this.selected.department,
				"') && contains(rec.submission.data.appraiseeUsername,'",
				this.selected.fitcorper,
				"') && contains(rec.submission.data.appraiserUsername,'",
				this.current_username,
				"') && contains(rec.submission.data.year.name,'",
				this.selected.year,
				"') && contains(rec.submission.data.quater.name,'",
				this.selected.quarter,
				"') && contains(rec.submission.data.type.name,'",//
				this.selected.form_type,//
				"') return 1"
			]
			check = check.join("");
			var res = await comm.getFormData(check);

			if (res.data.length > 0) {
				ret = true;
			}
			return ret;
		},
		year_on_continue() {
			if (this.selected.year.trim() == "") {
				general.wMsgBox.Error("Please select year before click continue.");
				return;
			}
			this.stepper.current_step = 2;
		},
		quarter_on_continue() {
			if (this.selected.quarter.trim() == "") {
				general.wMsgBox.Error("Please select quarter before click continue.");
				return;
			}
			this.stepper.current_step = 3;
		},
		async hub_on_continue() {
			if (this.selected.hub.trim() == "") {
				general.wMsgBox.Error("Please select hub before click continue.");
				return;
			}
			await this.get_employee(this.selected.hub);
			this.stepper.current_step = 4;
		},
		async fitcorper_on_change(e) {
			var el = this.stepper.fitcorpers.find((obj) => {
				return obj.user__username == e;
			});

			this.selected.fitcorper_fullname = el.full_name;
			this.selected.department = await this.get_derpartment(el);
			this.selected.jobgrade_position = el.emp_jg_position__job_grade__name + " - " + el.emp_jg_position__position__desc;
			this.selected.form_info = this.base.all_forms.find((form) => {
				return form.form_name == el.emp_jg_position__position__jd_form;
			});
		},
		async submit_on_click() {
			if (this.selected.form_type.trim() == "") {
				general.wMsgBox.Error("Please select form type before click continue.");
				return;
			}

			var record_existed = await this.check_rec_exist();

			if (record_existed) {
				var msg = [
					"Your appraisal for ",
					this.selected.fitcorper_fullname,
					" (",
					this.selected.year,
					"-",
					this.selected.quarter,
					": ",
					this.selected.form_type,
					") has been submitted."
				];
				general.wMsgBox.Error(msg.join(""));
				this.selected.iframe.url = "";
			} else {
				this.stepper.current_step = 6;

				var url = [
					comm.form_ip,
					this.selected.form_info.form_id,
					"&username=",
					this.current_username,
					"&userfullname=",
					this.userfullname,
					"&hub=",
					this.selected.hub,
					"&department=",
					this.selected.department,
					"&appraisee=",
					this.selected.fitcorper_fullname,
					"&appraisee_username=",
					this.selected.fitcorper,
					"&year=",
					this.selected.year,
					"&quarter=",
					this.selected.quarter,
					"&appraisal_type=",
					this.selected.form_type
				];
				this.selected.iframe.url = url.join("");
			}
		},
		fitcorper_on_continue() {
			if (this.selected.fitcorper.trim() == "") {
				general.wMsgBox.Error("Please select fitcorper before click continue.");
				return;
			}

			if (this.current_username == this.selected.fitcorper) {
				this.stepper.forms_type = this.base.forms_type.filter((form) => {
					var regex = new RegExp('self', 'i');

					return regex.test(form.name);
				});
			} else {
				var down_stream_member = this.base.all_members.find((el) => {
					return el == this.selected.fitcorper;
				});

				if (down_stream_member != undefined) {
					this.stepper.forms_type = this.base.forms_type.filter((form) => {
						var regex = new RegExp('superior', 'i');

						return regex.test(form.name);
					});
				} else {
					this.stepper.forms_type = this.base.forms_type.filter((form) => {
						var regex = new RegExp('peer', 'i');

						return regex.test(form.name);
					});
				}
			}
			this.stepper.current_step = 5;
		},
		async get_employee(company_name) {
			let cls_qb = new qb.QueryBuilder();
			cls_qb.Method = "all";

			// NOTE: call for employee listing
			cls_qb.Table = "emps_employee";
			cls_qb.Select = [
				"id",
				"full_name",
				"user__username",
				"emp_jg_position__position__jd_form",
				"emp_jg_position__position__desc",
				"emp_jg_position__job_grade__name",
				"cost_center__name",
				"cost_center__company__name"
			];

			var rule = new qb.Rule();
			rule
				.field("cost_center__company__name")
				.operator(qb.STR_OPERATOR.I_EQUAL)
				.value(company_name);
			cls_qb.addRule(rule);

			// OWK: only active staffs
			rule = new qb.Rule();
			rule
				.field("emp_status_id")
				.operator(qb.NUM_OPERATOR.EQUAL)
				.value(1);
			cls_qb.addRule(rule);

			cls_qb.Order = ["full_name"];
			let result = await general.wBackEndComm.PostData("process_qb/", cls_qb);

			if (result.data.Status == 1) {
				this.stepper.fitcorpers = result.data.Body.records;
			} else {
				general.wMsgBox.Error(result.data.Description);
			}
		},
		get_derpartment: async function (e) {
			this.selected.department = "";

			let cls_qb = new qb.QueryBuilder();
			cls_qb.Method = "all";

			cls_qb.Table = "emps_dept_employee";
			cls_qb.Select = ["emp__id", "dept__name"];

			var rule = new qb.Rule();
			rule
				.field("emp__id")
				.operator(qb.NUM_OPERATOR.EQUAL)
				.value(e.id);
			cls_qb.addRule(rule);

			// cls_qb.Order = ["full_name"];
			let result = await general.wBackEndComm.PostData("process_qb/", cls_qb);

			if (result.data.Status == 1) {
				if (result.data.Body.records.length > 0) {
					return result.data.Body.records[0].dept__name;
				} else {
					general.wMsgBox.Info(
						"Contact administrator for department configuration."
					);
				}
			} else {
				general.wMsgBox.Error(result.data.Description);
			}
		},
	},
};
</script>

<style></style>
